import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TutorialComponent } from 'app/account/tutorials/tutorial/tutorial.component';
import { trigger, transition, style, animate } from '@angular/animations';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-chat-widget',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    TutorialComponent,
    TranslocoModule
  ],
  templateUrl: './chat-widget.component.html',
  styleUrl: './chat-widget.component.scss',
  animations: [
    trigger('chatBoxAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(20px)' })),
      ]),
    ]),
  ],
})
export class ChatWidgetComponent implements OnInit, OnDestroy {
  isOpen: boolean = false;
  lang: string = 'en';
  private _unsubscribeAll: Subject<any> = new Subject<any>();


  toggleChat() {
    this.isOpen = !this.isOpen;
  }

  constructor(private _translocoService: TranslocoService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {

  }

  ngOnInit() {
    this._translocoService.langChanges$.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
      this.lang = res;
      this._changeDetectorRef.markForCheck();
    })

  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
